import React, { useEffect, useRef, memo } from 'react';
import { toolboxFlowsTriggerButtons } from '../../pages/action-journey-studio/toolbox/constants';
import { CHOICE_NODE_TYPE } from '../../pages/action-journey-studio/common/const/node-types';
import './edge_drop_menu.scss';

const EdgeDropMenu = ({ x, y, onSelect, onClose }) => {
    const menuRef = useRef(null);

    // Close on outside click or Escape key
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        // Delay adding click listener so the current mouseup doesn't immediately close it
        const timer = setTimeout(() => {
            document.addEventListener('mousedown', handleClickOutside);
        }, 100);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            clearTimeout(timer);
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

    // Adjust position so the menu doesn't overflow the viewport
    const adjustedStyle = {
        top: y,
        left: x,
    };

    // Filter toolbox groups that have draggable nodes (exclude variable, save, etc.)
    const nodeGroups = toolboxFlowsTriggerButtons.filter(
        (group) => group.nodes && group.nodes.length > 0 && !group.event
    );

    const handleItemClick = (node) => {
        onSelect({
            nodeType: node.id,
            label: node.text,
            stateConfig: node.defaultConfig || (node.id === CHOICE_NODE_TYPE ? { choices: [] } : undefined),
        });
    };

    return (
        <div
            className="edge-drop-menu"
            ref={menuRef}
            style={adjustedStyle}
        >
            <div className="edge-drop-menu__header">Add Step</div>
            <div className="edge-drop-menu__body">
                {nodeGroups.map((group) => (
                    <div key={group.id} className="edge-drop-menu__group">
                        <div className="edge-drop-menu__group-title">
                            {group.icon && <group.icon className="edge-drop-menu__group-icon" />}
                            {group.title}
                        </div>
                        {group.nodes.map((node) => {
                            const NodeIcon = node.icon;
                            return (
                                <div
                                    key={node.id}
                                    className="edge-drop-menu__item"
                                    onClick={() => handleItemClick(node)}
                                >
                                    {NodeIcon && <NodeIcon className="edge-drop-menu__item-icon" />}
                                    <span>{node.text}</span>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default memo(EdgeDropMenu);
